import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
// Styles
import styles from './main.module.css';
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../../node_modules/font-awesome/css/font-awesome.min.css';
// General
import { pageNotFound } from '../common/components';
import ConfirmMail from '../modules/view/Components/UserSetting/UserMailConfirm/userMailConfirm';
import CookieConsent from '../components/CookieConsent/CookieConsent';
import CustomerFailure from '../modules/Payment/CustomerFailure';
import CustomerSuccess from '../modules/Payment/CustomerSuccess';
import EmailChange from '../modules/EmailChange/EmailChangeVerify';
import FailurePayment from '../modules/Payment/FailurePayment';
import Login from '../modules/Login/Login';
import Offline from '../modules/Offline/Offline';
import OauthLogin from '../modules/OauthLogin/OauthLogin';
import PaymentReAuth from "../modules/Payment/PaymentReauth";
import PaymentReturn from "../modules/Payment/PaymentReturn";
import Plan from '../modules/Plan/Plan';
import Register from '../modules/Register/Register';
import SuccessPayment from "../modules/Payment/SuccessPayment";
import Verify from '../modules/Verify/verify';
import View from '../modules/view/view';
// Modules > Pages
//old
// import AboutUS from '../modules/AboutUs/aboutUs';
// import ContactUs from '../modules/Home/ContactUs/ContactUs';
// import Features from '../modules/Home/Features/Features';
// import Home from '../modules/Home/Home';
// import IcalInfo from '../modules/IcalInfo/ICalExplanation';
// import Pricing from '../modules/Home/Pricing/Pricing';
//new
import AboutUS from '../modules/pages/AboutUs/aboutUs';
import ContactUs from '../modules/pages/ContactUs/ContactUs';
import Features from '../modules/pages/Features/Features';
import Home from '../modules/pages/Home/Home';
import IcalInfo from '../modules/pages/ICalExplanation/ICalExplanation';
import Pricing from '../modules/pages/Pricing/Pricing';
// Modules > Pages > legal
// import CookiePolicy from '../modules/Footer/Components/CookiePolicy';
// import Terms from '../modules/Footer/Components/Terms';
// import Privacy from '../modules/Footer/Components/Privacy';
import CookiePolicy from '../modules/pages/legal/CookiePolicy';
import Terms from '../modules/pages/legal/Terms';
import Privacy from '../modules/pages/legal/Privacy';


const getCookie = (name) => {
  const value = document.cookie;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};

const PrivateRoute = ({ component: Component, ...rest }) => {
  let user = useSelector(({ user }) => user && (user.user));
  return (
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /signin page
    <Route {...rest} render={(props) => (user ? <Component {...props} /> : <Redirect to="/login" />)} />
  );
};

const PublicRoute = ({ component: Component, restricted, ...rest }) => {
  let user = useSelector(({ user }) => user && user.user);
  return (
    // restricted = false meaning public route
    // restricted = true meaning restricted route
    <Route {...rest} render={(props) => (user && restricted ? <Redirect to="/view" /> : <Component {...props} />)} />
  );
};

const RedirectRoute = ({ component: Component, restricted, ...rest }) => {
  let authToken = getCookie('BeehazToken') || '';
  return (
    <Route {...rest} render={(props) => (authToken !== '' ? <Redirect to={`/verify/${authToken}`} /> : <Component {...props} />)} />
  );
};

const Routes = () => {
  return (
    <Router>
      <div className="app-container">
        <Switch>
          <RedirectRoute exact path="/" component={Home} />
          <Route exact path={'/terms'} component={Terms} />
          <Route exact path={'/privacy-policy'} component={Privacy} />
          <Route exact path={'/cookie-policy'} component={CookiePolicy} />
          <Route exact path={'/ical-info'} component={IcalInfo} />
          <Route exact path={'/contact-us'} component={ContactUs} />
          <Route exact path={'/offline'} component={Offline} />
          <PublicRoute restricted={false} exact path="/about-us" component={AboutUS} />
          <Route exact path="/plan" component={Plan} />
          <PublicRoute exact path="/emailChange/:token" component={EmailChange} />
          <PublicRoute restricted={true} exact path="/register" component={Register} />
          <PrivateRoute restricted={true} exact path="/view" component={View} />
          <PrivateRoute restricted={true} path="/view" component={View} />
          <PublicRoute restricted={true} exact path="/verify/:token" component={Verify} />
          <PublicRoute restricted={true} exact path={'/confirm/:token'} component={ConfirmMail} />
          <PublicRoute restricted={true} exact path="/login" component={Login} />
          <PublicRoute restricted={false} exact path="/login_callback" component={OauthLogin} />
          <PublicRoute restricted={false} exact path="/pricing" component={Pricing} />
          <PublicRoute restricted={false} exact path="/features" component={Features} />
          <PublicRoute restricted={false} exact path="/payment/success" component={SuccessPayment} />
          <PublicRoute restricted={false} exact path={"/payment/customer_success"} component={CustomerSuccess} />
          <PublicRoute restricted={false} exact path={"/payment/customer_failure"} component={CustomerFailure} />
          <PublicRoute restricted={false} exact path={"/payment/cancel"} component={FailurePayment} />
          <PublicRoute restricted={false} exact path={"/payment/return"} component={PaymentReturn} />
          <PublicRoute restricted={false} exact path={"/payment/reauth"} component={PaymentReAuth} />
          <PublicRoute restricted={false} exact path="/pageNotFound" component={pageNotFound} />
          <PublicRoute restricted={false} path component={pageNotFound} />
        </Switch>
        <CookieConsent cookieName={'beehazState'} />
      </div>
    </Router>
  );
};
export default Routes;
